import { createAsyncThunk } from "@reduxjs/toolkit";
import { simpleUserVO } from "../../types/simpleTest";
import { executePromise } from "../../util/sliceUtil";
import { SimpleTestApi } from "../../api/simpleTestApi";

export const createSimpleUserAsync = createAsyncThunk("dcas-simple/user", (simpleUserVO: simpleUserVO) =>
  executePromise(SimpleTestApi.createSimpleUser(simpleUserVO))
);
